import get from 'lodash/get';
import { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import styles from './StoresAccordion.module.scss';

function StoresAccordion({ stores, regions, setStore }) {
  const [regionStores, setRegionStores] = useState('');
  const [currRegions, setCurrRegions] = useState();

  function sortRegionStore(regionStore) {
    return regionStore.sort((a, b) => {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    });
  }

  useEffect(() => {
    const _regionStores = regions.map(region => {
      const storeUUIDs = get(region, 'fields.stores');
      if (!storeUUIDs) return null;

      return storeUUIDs.flatMap(uuid => stores.filter(s => s.uuid === uuid));
    });
    _regionStores.flatMap(s => sortRegionStore(s));
    setRegionStores(_regionStores);
    setCurrRegions(regions);
  }, []);

  if (!regionStores || !currRegions) return null;

  return (
    <div>
      <Accordion>
        {currRegions.map((region, index) => {
          return (
            <AccordionItem key={region.uuid}>
              <AccordionItemHeading>
                <AccordionItemButton className={styles.accordionBtn}>
                  <button className={styles.btn} id={index}>
                    {`ΝΟΜΟΣ ${region.title}`}
                  </button>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className={styles.accordionPanel}>
                <Accordion>
                  {regionStores[index].map(s => (
                    <AccordionItem key={s.uuid}>
                      <AccordionItemHeading>
                        <AccordionItemButton className={styles.accordionInnerBtn}>
                          <button className={styles.innerBtn} id={index} onClick={() => setStore(s)}>
                            {`Κατάστημα ${s.title}`}
                          </button>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel className={styles.accordionInnerPanel}>
                        <div className={styles.text}>
                          <span className={styles.storeTitle}>Διεύθυνση:</span>
                          <span className={styles.storeDetails}> {s.fields.address}</span>
                        </div>
                        <div className={styles.text}>
                          <span className={styles.storeTitle}>Τηλέφωνο:</span>
                          <span className={styles.storeDetails}> {s.fields.phone}</span>
                        </div>
                        <div className={styles.text}>
                          <span className={styles.storeTitle}>Ωράριο:</span>
                          <span className={styles.storeDetailsHours}> {s.fields.work_hours}</span>
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                </Accordion>
              </AccordionItemPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}

export default StoresAccordion;
